import { HttpErrorResponse } from '@angular/common/http';
import { EntityState } from '@ngrx/entity';
import { GetAnnouncementDto } from '../../dtos/get-announcement-dto.interface';

export interface IAnnouncementsFeatureState extends EntityState<GetAnnouncementDto> {
    userAnnouncements: GetAnnouncementDto[];
    selectedAnnouncementId: string | null;
    loading: boolean;
    error: string | null | HttpErrorResponse;
    dismissingAnnouncementId: string | null;
}
